import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialPostOrderFeedbackState } from './initialState'

const slice = createSlice({
  name: 'postOrderFeedback',
  initialState: initialPostOrderFeedbackState,
  reducers: {
    setAllowPostOrderFeedbackEmail: (state, action: PayloadAction<boolean>) => {
      state.allowPostOrderFeedbackEmail = action.payload
    },
    resetForm: (
      state,
      action: PayloadAction<{
        allowPostOrderFeedbackEmail: boolean
      }>
    ) => {
      state.allowPostOrderFeedbackEmail =
        action.payload.allowPostOrderFeedbackEmail
    },
    setFormSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitting = action.payload
    },
  },
})

export const reducer = slice.reducer
export const { setFormSubmitting, setAllowPostOrderFeedbackEmail, resetForm } =
  slice.actions
